<template>
	<div class="scrollable only-y">
	<div :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
		<div class="page-header card-base card-shadow--medium">
			<h2 class="no-m white-text">
                Report Transaction
            </h2>
		</div>
	</div>
	<el-card>
		<el-tabs type="border-card" v-model="activeTab" v-loading="loadingPage">
			<el-tab-pane label="DAMCORP" name="damcorp">
                <el-row>
                    <el-form :inline="true" class="demo-form-inline">
                        <!-- <el-select placeholder="Source" style="width:140px;" size="mini" :default-first-option="true" class="mb-10 mr-5" v-model="filterDamcorp.source">
                            <el-option
                                v-for="item in source"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>

                        <el-select placeholder="Date Type" style="width:140px;" size="mini" :default-first-option="true" class="mb-10 mr-5" v-model="filterDamcorp.dateType">
                            <el-option
                                v-for="item in dateType"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select> -->

                        <el-select placeholder="Client Name" style="width:140px;" size="mini" :default-first-option="true" class="mb-10 mr-5" v-model="filterDamcorp.clientName" @change="selectClientFilter">
                            <el-option
                                v-for="item in listClient"
                                :label="item.name"
                                :value="item.id"
                                :key="item.id"
                            ></el-option>
                        </el-select>

                        <el-select placeholder="Company Name" style="width:140px;" size="mini" :default-first-option="true" class="mb-10 mr-5" v-model="filterDamcorp.companyName" @change="selectPhoneNumber('damcorp')" :disabled="!filterDamcorp.clientName">
                            <el-option
                                v-for="item in listCustomerClient"
                                :label="item.customer_name"
                                :value="item.customer_id"
                                :key="item.customer_id"
                            ></el-option>
                        </el-select>

                        <el-date-picker class="mr-5 mb-10"
                            style="top: 2px !important; width:220px;"
                            v-model="filterDamcorp.selectedStartDate"
                            :picker-options="pickerOptions"
                            range-separator="to"
                            size="mini"
                            type="daterange"
                            placeholder="Range Date">
                        </el-date-picker>

                        <el-select placeholder="Phone Number" style="width:140px;" size="mini" :default-first-option="true" class="mb-10 mr-5" v-model="filterDamcorp.phoneNumber" :disabled="!filterDamcorp.companyName">
                            <el-option
                                v-for="(item, idx) in listPhoneNumber"
                                :label="item.phone_number"
                                :value="item.phone_number"
                                :key="idx"
                            ></el-option>
                        </el-select>

                        <!-- <el-select placeholder="Search Category" style="width:140px;" size="mini" :default-first-option="true" class="mb-10 mr-5" v-model="filterDamcorp.category">
                            <el-option
                                v-for="item in searchCategory"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>

                        <el-input
                            style="width:200px;"
                            class="mb-10"
                            size="mini"
                            prefix-icon="el-icon-search"
                            placeholder="Search Value"
                            v-model="filterDamcorp.searchValue"
                            clearable
                        /> -->
                                
                        <el-button-group class="mr-10 ml-10">
                            <el-button type="primary" round size="mini" :loading="loadingReportTable" class="animated fadeInRight" style="background-color: #0047FF;" @click="searchDamcorp" :disabled="!filterDamcorp.phoneNumber">
                                <i class="el-icon-search"/>
                            </el-button>
                        </el-button-group>
                        
                        <el-select placeholder="Download Category" style="width:160px;" size="mini" :default-first-option="true" class="mb-10 mr-5" v-model="download_category">
                            <el-option
                                v-for="item in downloadCategory"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                        <el-button type="primary" size="mini" class="animated fadeInRight" :disabled="!filterDamcorp.phoneNumber || !download_category" @click="downloadCategoryReport">
                            <i class="mdi mdi-download"/>
                        </el-button>
                    </el-form>
                </el-row>
				<el-row :gutter="10" style="z-index: 0">
					<el-col class="mt-10" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                        <el-card shadow="card-shadow--small">
							<div class="group-list scrollable only-y">
								<template>
                                    <table style="width: 100%;" border="1" class="table-report">
                                        <thead>
                                            <tr>
                                                <th style="padding: .5em 2em;">
                                                    <p>CONVERSATION</p>
                                                </th>
                                                <th colspan="3" style="padding: .5em 2em;">
                                                    <p>DAMCORP</p>
                                                </th>
                                                <th colspan="3" style="padding: .5em 2em;">
                                                    <p>META</p>
                                                </th>
                                                <th style="padding: .5em 2em;">
                                                    <p>COMPARE</p>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody
                                            v-if="listReportDamcorp && listReportDamcorp.traffic.length > 0"
                                            v-for="(item, idx) in listReportDamcorp.traffic"
                                            :key="idx"
                                        >
                                            <!-- authentication -->
                                            <tr>
                                                <td style="padding: 0 .3em; min-width: 5em;" rowspan="4">
                                                    <p>Authentication</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>Charge</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>{{item.usage.dkd.authentication.charge}}</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;" rowspan="2">
                                                    <p>{{item.usage.dkd.authentication.return + item.usage.dkd.authentication.charge}}</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>Paid</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>{{item.usage.meta.authentication.charge}}</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;" rowspan="2">
                                                    <p>{{item.usage.meta.authentication.charge + item.usage.meta.authentication.free_tier}}</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;" rowspan="2">
                                                    <p style="font-weight: bold">
                                                        {{
                                                            (item.usage.dkd.authentication.charge + item.usage.dkd.authentication.return) === (item.usage.meta.authentication.charge + item.usage.meta.authentication.free_tier)
                                                            ? 'PASS'
                                                            : (item.usage.dkd.authentication.charge + item.usage.dkd.authentication.return) < (item.usage.meta.authentication.charge + item.usage.meta.authentication.free_tier)
                                                            ? 'ISSUE TO HIGH'
                                                            : 'ISSUE TO LOW'
                                                        }}
                                                    </p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>Credit Deduction</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>{{item.usage.dkd.authentication.return}}</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>Free Tier</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>{{item.usage.meta.authentication.free_tier}}</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>Free Entry Point</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;" colspan="2">
                                                    <p>{{item.usage.dkd.authentication.free_entry_point}}</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;" rowspan="2">
                                                    <p>Free Entry Point</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;" rowspan="2" colspan="2">
                                                    <p>{{item.usage.meta.authentication.free_entry_point}}</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;" rowspan="2">
                                                    <p style="font-weight: bold">
                                                        {{
                                                            (item.usage.dkd.authentication.free_entry_point) === (item.usage.meta.authentication.free_entry_point)
                                                            ? 'PASS'
                                                            : (item.usage.dkd.authentication.free_entry_point) < (item.usage.meta.authentication.free_entry_point)
                                                            ? 'ISSUE TO HIGH'
                                                            : 'ISSUE TO LOW'
                                                        }}
                                                    </p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>Marked</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;" colspan="2">
                                                    <p>{{item.usage.dkd.authentication.marked}}</p>
                                                </td>
                                            </tr>

                                            <!-- marketing -->
                                            <tr>
                                                <td style="padding: 0 .3em; min-width: 5em;" rowspan="4">
                                                    <p>Marketing</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>Charge</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>{{item.usage.dkd.marketing.charge}}</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;" rowspan="2">
                                                    <p>{{item.usage.dkd.marketing.return + item.usage.dkd.marketing.charge}}</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>Paid</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>{{item.usage.meta.marketing.charge}}</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;" rowspan="2">
                                                    <p>{{item.usage.meta.marketing.charge + item.usage.meta.marketing.free_tier}}</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;" rowspan="2">
                                                    <p style="font-weight: bold">
                                                        {{
                                                            (item.usage.dkd.marketing.charge + item.usage.dkd.marketing.return) === (item.usage.meta.marketing.charge + item.usage.meta.marketing.free_tier)
                                                            ? 'PASS'
                                                            : (item.usage.dkd.marketing.charge + item.usage.dkd.marketing.return) < (item.usage.meta.marketing.charge + item.usage.meta.marketing.free_tier)
                                                            ? 'ISSUE TO HIGH'
                                                            : 'ISSUE TO LOW'
                                                        }}
                                                    </p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>Credit Deduction</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>{{item.usage.dkd.marketing.return}}</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>Free Tier</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>{{item.usage.meta.marketing.free_tier}}</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>Free Entry Point</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;" colspan="2">
                                                    <p>{{item.usage.dkd.marketing.free_entry_point}}</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;" rowspan="2">
                                                    <p>Free Entry Point</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;" rowspan="2" colspan="2">
                                                    <p>{{item.usage.meta.marketing.free_entry_point}}</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;" rowspan="2">
                                                    <p style="font-weight: bold">
                                                        {{
                                                            (item.usage.dkd.marketing.free_entry_point) === (item.usage.meta.marketing.free_entry_point)
                                                            ? 'PASS'
                                                            : (item.usage.dkd.marketing.free_entry_point) < (item.usage.meta.marketing.free_entry_point)
                                                            ? 'ISSUE TO HIGH'
                                                            : 'ISSUE TO LOW'
                                                        }}
                                                    </p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>Marked</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;" colspan="2">
                                                    <p>{{item.usage.dkd.marketing.marked}}</p>
                                                </td>
                                            </tr>

                                            <!-- utility -->
                                            <tr>
                                                <td style="padding: 0 .3em; min-width: 5em;" rowspan="4">
                                                    <p>Utility</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>Charge</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>{{item.usage.dkd.utility.charge}}</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;" rowspan="2">
                                                    <p>{{item.usage.dkd.utility.return + item.usage.dkd.utility.charge}}</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>Paid</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>{{item.usage.meta.utility.charge}}</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;" rowspan="2">
                                                    <p>{{item.usage.meta.utility.charge + item.usage.meta.utility.free_tier}}</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;" rowspan="2">
                                                    <p style="font-weight: bold">
                                                        {{
                                                            (item.usage.dkd.utility.charge + item.usage.dkd.utility.return) === (item.usage.meta.utility.charge + item.usage.meta.utility.free_tier)
                                                            ? 'PASS'
                                                            : (item.usage.dkd.utility.charge + item.usage.dkd.utility.return) < (item.usage.meta.utility.charge + item.usage.meta.utility.free_tier)
                                                            ? 'ISSUE TO HIGH'
                                                            : 'ISSUE TO LOW'
                                                        }}
                                                    </p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>Credit Deduction</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>{{item.usage.dkd.utility.return}}</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>Free Tier</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>{{item.usage.meta.utility.free_tier}}</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>Free Entry Point</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;" colspan="2">
                                                    <p>{{item.usage.dkd.utility.free_entry_point}}</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;" rowspan="2">
                                                    <p>Free Entry Point</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;" rowspan="2" colspan="2">
                                                    <p>{{item.usage.meta.utility.free_entry_point}}</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;" rowspan="2">
                                                    <p style="font-weight: bold">
                                                        {{
                                                            (item.usage.dkd.utility.free_entry_point) === (item.usage.meta.utility.free_entry_point)
                                                            ? 'PASS'
                                                            : (item.usage.dkd.utility.free_entry_point) < (item.usage.meta.utility.free_entry_point)
                                                            ? 'ISSUE TO HIGH'
                                                            : 'ISSUE TO LOW'
                                                        }}
                                                    </p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>Marked</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;" colspan="2">
                                                    <p>{{item.usage.dkd.utility.marked}}</p>
                                                </td>
                                            </tr>

                                            <!-- service -->
                                            <tr>
                                                <td style="padding: 0 .3em; min-width: 5em;" rowspan="4">
                                                    <p>Service</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>Charge</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>{{item.usage.dkd.service.charge}}</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;" rowspan="2">
                                                    <p>{{item.usage.dkd.service.return + item.usage.dkd.service.charge}}</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>Paid</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>{{item.usage.meta.service.charge}}</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;" rowspan="2">
                                                    <p>{{item.usage.meta.service.charge + item.usage.meta.service.free_tier}}</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;" rowspan="2">
                                                    <p style="font-weight: bold">
                                                        {{
                                                            (item.usage.dkd.service.charge + item.usage.dkd.service.return) === (item.usage.meta.service.charge + item.usage.meta.service.free_tier)
                                                            ? 'PASS'
                                                            : (item.usage.dkd.service.charge + item.usage.dkd.service.return) < (item.usage.meta.service.charge + item.usage.meta.service.free_tier)
                                                            ? 'ISSUE TO HIGH'
                                                            : 'ISSUE TO LOW'
                                                        }}
                                                    </p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>Credit Deduction</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>{{item.usage.dkd.service.return}}</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>Free Tier</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>{{item.usage.meta.service.free_tier}}</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>Free Entry Point</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;" colspan="2">
                                                    <p>{{item.usage.dkd.service.free_entry_point}}</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;" rowspan="2">
                                                    <p>Free Entry Point</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;" rowspan="2" colspan="2">
                                                    <p>{{item.usage.meta.service.free_entry_point}}</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;" rowspan="2">
                                                    <p style="font-weight: bold">
                                                        {{
                                                            (item.usage.dkd.service.free_entry_point) === (item.usage.meta.service.free_entry_point)
                                                            ? 'PASS'
                                                            : (item.usage.dkd.service.free_entry_point) < (item.usage.meta.service.free_entry_point)
                                                            ? 'ISSUE TO HIGH'
                                                            : 'ISSUE TO LOW'
                                                        }}
                                                    </p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style="padding: 0 .3em; min-width: 5em;">
                                                    <p>Marked</p>
                                                </td>
                                                <td style="padding: 0 .3em; min-width: 5em;" colspan="2">
                                                    <p>{{item.usage.dkd.service.marked}}</p>
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tbody v-if="!listReportDamcorp.traffic">
                                            <tr>
                                                <td style="text-align: center; padding: 1em 0; color: #000;" colspan="8">No Data</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </template>
                            </div>
                        </el-card>
					</el-col>
				</el-row>
                <el-row class="mt-10" style="font-size:14px;">
                    <h3>Traffic Report</h3>
                    <el-col :span="4" :md="4" :sm="4" :xs="4" justify="end">
                        <el-card style="background-color:#5EA369; font-size:12px; color:#ffffff; font-weight:bold; min-height:125px; word-wrap: break-word; text-align: center;" class="mb-10">
                            <span style="font-size:14px;">Message Created</span><br><br/>
                            <span style="font-size:34px;">
                                {{ totalDataReportTraffic.all ? totalDataReportTraffic.all : 0 }}
                            </span>
                        </el-card>
                    </el-col>
                    <el-col :span="4" :md="4" :sm="4" :xs="4" justify="end">
                        <el-card style="background-color:#8CBC26; font-size:12px; color:#ffffff; font-weight:bold; min-height:125px; word-wrap: break-word; text-align: center;" class="mb-10">
                            <span style="font-size:14px;">Send</span><br><br>
                            <span style="font-size:34px;">
                                {{ totalDataReportTraffic.sending ? totalDataReportTraffic.sending : 0 }}
                            </span>
                        </el-card>
                    </el-col>
                    <el-col :span="4" :md="4" :sm="4" :xs="4" justify="end">
                        <el-card style="background-color:#5EA369; font-size:12px; color:#ffffff; font-weight:bold; min-height:125px; word-wrap: break-word; text-align: center;" class="mb-10">
                            <span style="font-size:14px;">Sent</span><br><br>
                            <span style="font-size:34px;">
                                {{ totalDataReportTraffic.sent ? totalDataReportTraffic.sent : 0 }}
                            </span>
                        </el-card>
                    </el-col>
                    <el-col :span="4" :md="4" :sm="4" :xs="4" justify="end">
                        <el-card style="background-color:#8CBC26; font-size:12px; color:#ffffff; font-weight:bold; min-height:125px; word-wrap: break-word; text-align: center;" class="mb-10">
                            <span style="font-size:14px;">Delivered</span><br><br>
                            <span style="font-size:34px;">
                                {{ totalDataReportTraffic.delivered ? totalDataReportTraffic.delivered : 0 }}
                            </span>
                        </el-card>
                    </el-col>
                    <el-col :span="4" :md="4" :sm="4" :xs="4" justify="end">
                        <el-card style="background-color:#5EA369; font-size:12px; color:#ffffff; font-weight:bold; min-height:125px; word-wrap: break-word; text-align: center;" class="mb-10">
                            <span style="font-size:14px;">Read</span><br><br>
                            <span style="font-size:34px;">
                                {{ totalDataReportTraffic.read ? totalDataReportTraffic.read : 0 }}
                            </span>
                        </el-card>
                    </el-col>
                    <el-col :span="4" :md="4" :sm="4" :xs="4" justify="end">
                        <el-card style="background-color:#8CBC26; font-size:12px; color:#ffffff; font-weight:bold; min-height:125px; word-wrap: break-word; text-align: center;" class="mb-10">
                            <span style="font-size:14px;">Failed and Invalid</span><br><br>
                            <el-tooltip placement="bottom">
                                <div slot="content">
                                    <p>Failed : {{ totalDataReportTraffic.failed ? totalDataReportTraffic.failed : 0 }}</p>
                                    <p>Invalid : {{ totalDataReportTraffic.invalid ? totalDataReportTraffic.invalid : 0 }}</p>
                                </div>
                                <span style="font-size:34px;">
                                    {{ totalDataReportTraffic.failed && totalDataReportTraffic.invalid ? (totalDataReportTraffic.failed + totalDataReportTraffic.invalid) : 0}}
                                </span>
                            </el-tooltip>
                        </el-card>
                    </el-col>
                </el-row>
                <el-row :gutter="10" style="z-index: 0">
					<el-col class="mt-10" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
						<el-card shadow="card-shadow--small">
                            <div class="group-list scrollable only-y">
                                <el-pagination
                                    background
                                    prev-text="Prev"
                                    next-text="Next"
                                    layout="prev, pager, next"
                                    :page-size="20"
                                    @current-change="paginateTraffic"
                                    :current-page="currentPageTraffic"
                                    :total="totalDataReportTraffic.all">
                                </el-pagination>
								<template>
									<el-table style="width: 100%; color: #000 !important" v-loading="loadingTable" element-loading-text="Loading..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(246, 246, 245, 0.8)" :data="listReportTraffic">
										<el-table-column width="150" label="Source">
											<template slot-scope="props">
                                                <p>-</p>
											</template>
										</el-table-column>
										<el-table-column width="150" label="Traffic Type">
                                            <template slot-scope="props">
                                                <p>{{props.row.type}}</p>
											</template>
                                        </el-table-column>
										<el-table-column width="150" label="From">
                                            <template slot-scope="props">
                                                <p>{{props.row.sender}}</p>
											</template>
                                        </el-table-column>
										<el-table-column width="150" label="To">
                                            <template slot-scope="props">
                                                <p>{{props.row.to}}</p>
											</template>
                                        </el-table-column>
										<el-table-column label="Created Date" width="150">
                                            <template slot-scope="props">
                                                <p>{{formatDate(props.row.created_date)}}</p>
											</template>
										</el-table-column>
                                        <el-table-column label="Status Date" width="150">
                                            <template slot-scope="props">
                                                <p>{{formatDate(props.row.latest_status_dt)}}</p>
											</template>
										</el-table-column>
										<el-table-column width="150" label="Status">
                                            <template slot-scope="props">
                                                <p style="text-transform:capitalize;">{{props.row.status}}</p>
											</template>
                                        </el-table-column>
										<el-table-column label="Market Area" width="150">
                                            <template slot-scope="props">
                                                <p>{{props.row.market_area}}</p>
											</template>
										</el-table-column>
                                        <el-table-column width="150" label="Conversation Type">
                                            <template slot-scope="props">
                                                <p v-if="props.row.template_category === 5">Authentication</p>
                                                <p v-else-if="props.row.template_category === 6">Marketing</p>
                                                <p v-else-if="props.row.template_category === 7">Utility</p>
                                                <p v-else-if="props.row.template_category === 8">Service</p>
                                                <p v-else>-</p>
											</template>
                                        </el-table-column>
										<el-table-column width="150" label="Template Name">
                                            <template slot-scope="props">
                                                <p>{{props.row.type.includes('hsm') ? props.row.type.split(':')[1] : '-'}}</p>
											</template>
                                        </el-table-column>
                                        <el-table-column width="150" label="Delivered Date">
                                            <template slot-scope="props">
                                                <p>{{props.row.status === 'delivered' ? formatDate(props.row.delivered_at) : '-'}}</p>
											</template>
                                        </el-table-column>
										<el-table-column width="150" label="Message ID">
                                            <template slot-scope="props">
                                                <p>{{props.row.msg_id}}</p>
											</template>
                                        </el-table-column>
										<el-table-column label="Bill Session" width="150">
                                            <template slot-scope="props">
                                                <p v-if="props.row.dkd_is_session === true && props.row.quota_status === 2">Charge</p>
                                                <p v-else-if="props.row.dkd_is_session==true && (props.row.latest_status == 'delivered' || props.row.latest_status == 'read')">Charge</p>
                                                <p v-else-if="props.row.dkd_is_session === true && props.row.quota_status === 1">Marked</p>
                                                <p v-else-if="props.row.dkd_is_session === true && props.row.quota_status === 3">Credit Return</p>
                                                <p v-else-if="props.row.dkd_is_session==true">Charge</p>
                                                <p v-else>Not Charge</p>
											</template>
										</el-table-column>
                                        <el-table-column width="150" label="Error Message">
                                            <template slot-scope="props">
                                                <p>{{ props.row.latest_error_message ? props.row.latest_error_message : '-' }}</p>
											</template>
                                        </el-table-column>
									</el-table>
								</template>
                                <el-pagination
                                    background
                                    prev-text="Prev"
                                    next-text="Next"
                                    layout="prev, pager, next"
                                    :page-size="20"
                                    @current-change="paginateTraffic"
                                    :current-page="currentPageTraffic"
                                    :total="totalDataReportTraffic.all">
                                </el-pagination>
							</div>
						</el-card>
					</el-col>
				</el-row>
			</el-tab-pane>
			<el-tab-pane label="Facebook" name="facebook">
				<el-row>
                    <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
                        <el-form :inline="true" class="demo-form-inline">
                            <el-date-picker class="mr-5 mb-10"
                                style="top: 2px !important; width:220px;"
                                v-model="filterFacebook.selectedStartDate"
                                :picker-options="pickerOptionsFacebook"
                                range-separator="to"
                                size="mini"
                                type="daterange"
                                placeholder="Range Date">
                            </el-date-picker>

                            <el-select v-model="filterFacebook.filterWabaIdFacebook" placeholder="WABA ID" style="width:140px;" size="mini" :default-first-option="true" class="mb-10 mr-5" filterable @change="selectPhoneNumberFilterFacebook('facebookFilter')">
                                <el-option
                                    v-for="(item, idx) in consumenData"
                                    :label="item.customer_name"
                                    :value="item.customer_id"
                                    :key="idx"
                                />
                            </el-select>

                            <el-select v-if="filterFacebook.filterWabaIdFacebook" v-model="filterFacebook.filterPhoneNumberFacebook" placeholder="Phone Number" style="width:140px;" size="mini" :default-first-option="true" class="mb-10 mr-5">
                                <el-option
                                    v-for="(item, idx) in listPhoneNumberFacebook"
                                    :label="item"
                                    :value="item"
                                    :key="idx"
                                ></el-option>
                            </el-select>

                            <el-select v-if="filterFacebook.filterPhoneNumberFacebook" v-model="filterFacebook.filterMarketAreaFacebook" placeholder="Market Area" style="width:140px;" size="mini" :default-first-option="true" class="mb-10 mr-5" filterable @change="selectMarket">
                                <el-option
									v-for="(item, key) in listMarketArea"
									:key="key"
									:label="item.name || '-'"
									:value="item.id"
                                >
								</el-option>
                            </el-select>

                            <el-select v-if="filterFacebook.filterMarketAreaFacebook" v-model="filterFacebook.filterCountriesFacebook" placeholder="Countries" style="width:140px;" size="mini" :default-first-option="true" class="mb-10 mr-5">
                                <el-option
									v-for="(item, key) in marketPrefixData"
									:key="key"
									:label="item.country_name || '-'"
									:value="item.country_name"
                                >
								</el-option>
                            </el-select>
                                    
                            <el-button-group class="mr-10 ml-10">
                                <el-button type="primary" round size="mini" :loading="loadingReportTable" class="animated fadeInRight" style="background-color: #0047FF;" @click="searchFacebook" :disabled="!filterFacebook.selectedStartDate || !filterFacebook.filterWabaIdFacebook || !filterFacebook.filterPhoneNumberFacebook || !filterFacebook.filterMarketAreaFacebook || !filterFacebook.filterCountriesFacebook">
                                    <i class="el-icon-search"/>
                                </el-button>
                            </el-button-group>

                            <!-- <el-button type="primary" size="mini" class="animated fadeInRight">
                                <i class="mdi mdi-download"/>
                            </el-button> -->
                        </el-form>
                    </el-col>
                </el-row>
                <el-row class="mb-10 mt-10" style="font-size:14px;">
                    <el-col :span="4" :md="6" :sm="6" :xs="6" justify="end">
                        <el-card style="background-color:#5EA369; font-size:12px; color:#ffffff; font-weight:bold; min-height:125px; word-wrap: break-word; text-align: center;" class="mb-10">
                            <span style="font-size:14px;">Active WABA</span><br><br/>
                            <span style="font-size:34px;">
                                {{listFacebookData.waba_active ? listFacebookData.waba_active : 0}}
                            </span>
                        </el-card>
                    </el-col>
                    <el-col :span="4" :md="6" :sm="6" :xs="6" justify="end">
                        <el-card style="background-color:#8CBC26; font-size:12px; color:#ffffff; font-weight:bold; min-height:125px; word-wrap: break-word; text-align: center;" class="mb-10">
                            <span style="font-size:14px;">Pasive WABA</span><br><br>
                            <span style="font-size:34px;">
                                {{listFacebookData.waba_pasive ? listFacebookData.waba_pasive : 0}}
                            </span>
                        </el-card>
                    </el-col>
                    <el-col :span="4" :md="6" :sm="6" :xs="6" justify="end">
                        <el-card style="background-color:#5EA369; font-size:12px; color:#ffffff; font-weight:bold; min-height:125px; word-wrap: break-word; text-align: center;" class="mb-10">
                            <span style="font-size:14px;">Active Phone Number</span><br><br>
                            <span style="font-size:34px;">
                                {{listFacebookData.phone_number_active ? listFacebookData.phone_number_active : 0}}
                            </span>
                        </el-card>
                    </el-col>
                    <el-col :span="4" :md="6" :sm="6" :xs="6" justify="end">
                        <el-card style="background-color:#5EA369; font-size:12px; color:#ffffff; font-weight:bold; min-height:125px; word-wrap: break-word; text-align: center;" class="mb-10">
                            <span style="font-size:14px;">Pasive Phone Number</span><br><br>
                            <span style="font-size:34px;">
                                {{listFacebookData.phone_number_passive ? listFacebookData.phone_number_passive : 0}}
                            </span>
                        </el-card>
                    </el-col>
                </el-row>
				<el-row :gutter="10" style="z-index: 0" v-loading="loadingReportTable">
                    <h3>Meta Conversation Report</h3>
					<el-col class="mt-10" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
						<el-card shadow="card-shadow--small">
							<div class="group-list scrollable only-y">
                                <template>
                                    <el-card>
                                        <el-row>
                                            <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
                                                <div>
                                                    <p><b>All Conversation</b></p>
                                                    <p>Authentication</p>
                                                    <p>Marketing</p>
                                                    <p>Utility</p>
                                                    <p>Service</p>
                                                </div>
                                            </el-col>
                                            <el-col :xs="14" :sm="14" :md="14" :lg="14" :xl="14">
                                                <div style="display:flex; gap: 4em;">
                                                    <div>
                                                        <p style="text-align:center;">
                                                            <b>Total</b>
                                                        </p>
                                                        <p style="text-align:center;">
                                                            {{ sumTotalReportFacebook(listReportFacebookData, 'authentication') }}
                                                        </p>
                                                        <p style="text-align:center;">
                                                            {{ sumTotalReportFacebook(listReportFacebookData, 'marketing') }}
                                                        </p>
                                                        <p style="text-align:center;">
                                                            {{ sumTotalReportFacebook(listReportFacebookData, 'utility') }}
                                                        </p>
                                                        <p style="text-align:center;">
                                                            {{ sumTotalReportFacebook(listReportFacebookData, 'service') }}
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <p style="text-align:center;">
                                                            <b>Paid</b>
                                                        </p>
                                                        <p style="text-align:center;">
                                                            {{ sumTotalReportFacebook(listReportFacebookData, 'paidAuthentication') }}
                                                        </p>
                                                        <p style="text-align:center;">
                                                            {{ sumTotalReportFacebook(listReportFacebookData, 'paidMarketing') }}
                                                        </p>
                                                        <p style="text-align:center;">
                                                            {{ sumTotalReportFacebook(listReportFacebookData, 'paidUtility') }}
                                                        </p>
                                                        <p style="text-align:center;">
                                                            {{ sumTotalReportFacebook(listReportFacebookData, 'paidService') }}
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <p style="text-align:center;">
                                                            <b>Tier</b>
                                                        </p>
                                                        <p style="text-align:center;">
                                                            {{ sumTotalReportFacebook(listReportFacebookData, 'tierAuthentication') }}
                                                        </p>
                                                        <p style="text-align:center;">
                                                            {{ sumTotalReportFacebook(listReportFacebookData, 'tierMarketing') }}
                                                        </p>
                                                        <p style="text-align:center;">
                                                            {{ sumTotalReportFacebook(listReportFacebookData, 'tierUtility') }}
                                                        </p>
                                                        <p style="text-align:center;">
                                                            {{ sumTotalReportFacebook(listReportFacebookData, 'tierService') }}
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <p style="text-align:center;">
                                                            <b>Free Entry Point</b>
                                                        </p>
                                                        <p style="text-align:center;">
                                                            {{ sumTotalReportFacebook(listReportFacebookData, 'entryAuthentication') }}
                                                        </p>
                                                        <p style="text-align:center;">
                                                            {{ sumTotalReportFacebook(listReportFacebookData, 'entryMarketing') }}
                                                        </p>
                                                        <p style="text-align:center;">
                                                            {{ sumTotalReportFacebook(listReportFacebookData, 'entryUtility') }}
                                                        </p>
                                                        <p style="text-align:center;">
                                                            {{ sumTotalReportFacebook(listReportFacebookData, 'entryService') }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </el-col>
                                            <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
                                                <div>
                                                    <p><b>Revenue</b></p>
                                                    <p style="text-align:left;">
                                                        Rp. {{ sumTotalReportFacebook(listReportFacebookData, 'revenueAuthentication') }}
                                                    </p>
                                                    <p style="text-align:left;">
                                                        Rp. {{ sumTotalReportFacebook(listReportFacebookData, 'revenueMarketing') }}
                                                    </p>
                                                    <p style="text-align:left;">
                                                        Rp. {{ sumTotalReportFacebook(listReportFacebookData, 'revenueUtility') }}
                                                    </p>
                                                    <p style="text-align:left;">
                                                        Rp. {{ sumTotalReportFacebook(listReportFacebookData, 'revenueService') }}
                                                    </p>
                                                </div>
                                            </el-col>
                                        </el-row>
                                    </el-card>
                                </template>
							</div>
						</el-card>
					</el-col>
				</el-row>
                <!-- <el-row class="mb-10" style="font-size:14px;">
                    <h3>Messages Trafic Report</h3>
                    <el-col :span="4" :md="6" :sm="6" :xs="6" justify="end">
                        <el-card style="background-color:#5EA369; font-size:12px; color:#ffffff; font-weight:bold; min-height:125px; word-wrap: break-word; text-align: center;" class="mb-10">
                            <span style="font-size:14px;">Message Sent (Outbond)</span><br><br/>
                            <table>
                                <tr>
                                    <th class="text-left">
                                        <span style="font-size:18px;">
                                            DAMCORP
                                        </span>
                                    </th>
                                    <td style="width: 100%; font-size:18px;">0</td>
                                </tr>
                                <tr>
                                    <th class="text-left">
                                        <span style="font-size:18px;">
                                            META
                                        </span>
                                    </th>
                                    <td style="width: 100%; font-size:18px;">0</td>
                                </tr>
                            </table>
                        </el-card>
                    </el-col>
                    <el-col :span="4" :md="6" :sm="6" :xs="6" justify="end">
                        <el-card style="background-color:#8CBC26; font-size:12px; color:#ffffff; font-weight:bold; min-height:125px; word-wrap: break-word; text-align: center;" class="mb-10">
                            <span style="font-size:14px;">Message Delivered</span><br><br>
                            <table>
                                <tr>
                                    <th class="text-left">
                                        <span style="font-size:18px;">
                                            DAMCORP
                                        </span>
                                    </th>
                                    <td style="width: 100%; font-size:18px;">0</td>
                                </tr>
                                <tr>
                                    <th class="text-left">
                                        <span style="font-size:18px;">
                                            META
                                        </span>
                                    </th>
                                    <td style="width: 100%; font-size:18px;">0</td>
                                </tr>
                            </table>
                        </el-card>
                    </el-col>
                </el-row> -->
			</el-tab-pane>
			<el-tab-pane label="Download" name="download">
				<el-row>
                    <el-form :inline="true" class="demo-form-inline">
                        <el-date-picker
                            class="mr-5 mb-10"
                            style="width:220px;"
                            v-model="filterDownload.selectedStartDate"
                            :picker-options="pickerOptions"
                            size="mini"
                            type="date"
                            placeholder="Request Range Date">
                        </el-date-picker>

                        <el-select placeholder="Client Name" style="width:140px;" size="mini" :default-first-option="true" class="mb-10 mr-5" v-model="filterDownload.clientName" @change="selectClientFilter('download')" clearable>
                            <el-option
                                v-for="(item, idx) in listClient"
                                :key="idx"
                                :label="item.name"
                                :value="item.id"
                            ></el-option>
                        </el-select>

                        <el-select placeholder="Company Name" style="width:140px;" size="mini" :default-first-option="true" class="mb-10 mr-5" v-model="filterDownload.companyName" @change="selectPhoneNumber('download')" v-if="filterDownload.clientName" clearable>
                            <el-option
                                v-for="item in listCustomerClientDownload"
                                :label="item.customer_name"
                                :value="item.customer_id"
                                :key="item.customer_id"
                            ></el-option>
                        </el-select>

                        <el-select placeholder="Phone Number" style="width:140px;" size="mini" :default-first-option="true" class="mb-10 mr-5" v-model="filterDownload.phoneNumber" v-if="filterDownload.companyName" clearable>
                            <el-option
                                v-for="item in listPhoneNumberDownload"
                                :label="item"
                                :value="item"
                                :key="item"
                            ></el-option>
                        </el-select>
                                
                        <el-button-group class="mr-10 ml-10">
                            <el-button
                                type="primary"
                                round
                                size="mini"
                                :loading="loadingReportDownload"
                                class="animated fadeInRight"
                                style="background-color: #0047FF;"
                                @click="searchReportDownload"
                                :disabled="!filterDownload.phoneNumber"
                            >
                                <i class="el-icon-search"/>
                            </el-button>
                        </el-button-group>
                    </el-form>
                </el-row>
				<el-row :gutter="10" style="z-index: 0" class="mt-30">
					<el-col
                        :xs="24"
                        :sm="24"
                        :md="24"
                        :lg="24"
                        :xl="24"
                        v-loading="loadingDownloadReport"
                        v-for="(item, idx) in reportsDownload"
                        :key="idx"
                    >
                        <el-card style="border: 1px solid #ebeef5" class="page-header box-card">
                            <el-row :gutter="30">
                                <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18">
                                    <span>
                                        <h2 class="no-m accent-text">{{item.title}}</h2>
                                        <p style="font-size: 14px" class="no-m">
                                            Report filter detail:
                                        </p>
                                        <br/>
                                        <table>
                                            <tr>
                                                <td style="width: 9em;">Tab</td>
                                                <td>: {{ item.parameter.reportingType === 'summary' || item.parameter.reportingType === 'reportdetail' || item.parameter.reportingType === 'reportdetail' ? 'DAMCORP' : 'FACEBOOK' }}</td>
                                            </tr>
                                            <tr>
                                                <td>Company Name</td>
                                                <td>: {{ item.customerName }}</td>
                                            </tr>
                                            <tr>
                                                <td>Phone Number</td>
                                                <td>: {{ item.parameter.number }}</td>
                                            </tr>
                                            <tr>
                                                <td>Phone Owner</td>
                                                <td>: -</td>
                                            </tr>
                                            <tr>
                                                <td>Type</td>
                                                <td>: -</td>
                                            </tr>
                                            <tr>
                                                <td>Download Category</td>
                                                <td>: {{ item.parameter.reportingType }}</td>
                                            </tr>
                                            <tr>
                                                <td>Period</td>
                                                <td>: {{ item.parameter.startDate }} - {{ item.parameter.endDate}}</td>
                                            </tr>
                                        </table><br/>
                                            Request at: {{formatDateHour(item.createdAt)}}
                                        <br/>
                                    </span>
                                </el-col>
                                <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" style="line-height: 15em;" class="d-flex align-item-center g-5">
                                    <a v-if="item.status == 'done'" class="el-button el-button--primary el-button--mini" target="_blank" :href="item.url.url">
										<i class="mdi mdi-download"/> Download
									</a>

									<el-button disabled v-else-if="item.status == 'waiting'" size="mini" type="warning">
										<i class="mdi mdi-history"/> Processing
									</el-button>

									<el-button disabled v-else size="mini" type="danger">
										<i class="mdi mdi-history"/> Failed
									</el-button>

                                    <el-button
                                        @click="deleteReport(item.session)"
                                        v-if="item.status == 'done' || item.status == 'failed' || item.status == 'waiting'"
                                        size="mini"
                                        type="text"
                                    >
                                        <i class="mdi mdi-delete text-danger" style="font-size: 24px; line-height: 100px; color: red !important;"/>
                                    </el-button>
                                </el-col>
                            </el-row>
                        </el-card>
    
                        <!-- <el-card v-if="lists.length < 1" style="border: 1px solid #ebeef5" class="page-header box-card card-base">
                            <p class="text item" align="center">
                                <img src="@/assets/images/no_report.png" width="120px"/><br/>
                                Files you download will appear here
                            </p>
                        </el-card> -->
					</el-col>
                    <el-col v-if="reportsDownload.length === 0" class="mt-30">
                        <el-card>
                            <p style="padding: 2em 0;text-align: center;">No data</p>
                        </el-card>
                    </el-col>
				</el-row>
			</el-tab-pane>
		</el-tabs>

	</el-card>
	<el-card class="mt-20 mb-20 card-base" style="border:none; color:white;">
		DAM Corp.
	</el-card>
	</div>
</template>

<script>
import api from '@/networkClient'
import config from '@/config'
import store from '@/store'
const _ = require('lodash')
const moment = require('moment')

export default {
    name: 'bussiness_report_transaction',
	components: {
	},
	data () {
		return {
            activeTab: 'damcorp',
            loadingTable: false,
            loadingReportTable: false,
            periodLimitSelect: [
                {
                    label: 'All',
                    value: ''
                },
                {
                    label: 'To expire in 3 months',
                    value: 3
                },
                {
                    label: 'To expire in 2 months',
                    value: 2
                },
                {
                    label: 'To expire in 1 month',
                    value: 1
                }
            ],
            source: [
                {
                    name: 'All',
                    value: ''
                },
                {
                    name: 'Api',
                    value: 'api'
                },
                {
                    name: 'Panel',
                    value: 'panel'
                }
            ],
            dateType: [
                {
                    name: 'Delivered',
                    value: 'delivered'
                },
                {
                    name: 'Created',
                    value: 'created'
                }
            ],
            searchCategory: [
                {
                    name: 'Recipient',
                    value: 'recipient'
                },
                {
                    name: 'Message ID',
                    value: 'message_id'
                },
                {
                    name: 'Template Name',
                    value: 'template_name'
                }
            ],
            downloadCategory: [
                {
                    name: 'Panel',
                    value: 'summary'
                },
                {
                    name: 'Detail',
                    value: 'reportdetail'
                },
                {
                    name: 'Realisasi',
                    value: 'realisasi'
                }
            ],
			selectedStartDate: [
                moment().subtract(1,"day").format("YYYY-MM-DD"),
                moment().subtract(1,"day").format("YYYY-MM-DD")
            ],
            loadingBtn: false,
            pickerOptions: {
				disabledDate: time => {
					var today = moment(), diff = today.diff(moment(time), 'd')
					if(diff > 1440 || diff < 0){
						return true
					} else {
						if(diff == 0){
							if(today.isSame(moment(time), 'd') == false){
								return true
							} else {
								return false
							}
						}
						return false
					}
				}
			},
            pickerOptionsFacebook: {
				disabledDate: time => {
					var today = moment().subtract(1,"day"), diff = today.diff(moment(time), 'd')
					if(diff > 1440 || diff < 0){
						return true
					} else {
						if(diff == 0){
							if(today.isSame(moment(time), 'd') == false){
								return true
							} else {
								return false
							}
						}
						return false
					}
				}
			},
            filterDamcorp: {
                searchValue: '',
                dateType: 'delivered',
                clientName: '',
                companyName: '',
                phoneNumber: '',
                category: '',
                searchValue: '',
                source: '',
                selectedStartDate: [
                    moment().subtract(1,"day").format("YYYY-MM-DD"),
                    moment().subtract(1,"day").format("YYYY-MM-DD")
                ],
            },
            filterFacebook: {
                selectedStartDate: [
                    moment().subtract(1,"day").format("YYYY-MM-DD"),
                    moment().subtract(1,"day").format("YYYY-MM-DD")
                ],
                filterWabaIdFacebook: '',
                filterPhoneNumberFacebook: '',
                filterMarketAreaFacebook: '',
                filterCountriesFacebook: '',
                filterFbbmIdFacebook: '',
                filterMarketCode: ''
            },
            filterDownload: {
                selectedStartDate: moment().format("YYYY-MM-DD"),
                clientName: '',
                companyName: '',
                phoneNumber: ''
            },
            selectFilterFacebook: [],
            download_category: '',
            listClient: [],
            listCustomerClient: [],
            listCustomer: [],
            listPhoneNumber: [],
            listReportTraffic: [],
            listFacebookData: {},
            listReportFacebookData: {},
            listReportDamcorp: {},
            listPhoneNumberDownload: [],
            msgCreated: 0,
            msgSent: [],
            msgSend: [],
            msgDelivered: [],
            msgRead: [],
            msgFailed: [],
            loadingDownloadReport: false,
            reportsDownload: [],
            totalReportDownload: 0,
            loadingReportDownload: false,
            listCustomerClientDownload: [],
            totalDataReportTraffic: {},
            currentPageTraffic: 1,
            fbIdentityWaba: [],
            fbIdentityFbbm: [],
            currentMonth: moment().format('YYYY-MM'),
            today: moment().format('DD MMM YYYY'),
			getMonth: moment().month()+1,
			getYear: moment().year(),
            loadingPage: false,
            assignData: [],
            listMarketArea: [],
            marketPrefixData: [],
            listPhoneNumberFacebook: [],
            consumenData: []
		}
	},
	methods: {
        log(data) {
            console.log(data, " <<data");
        },
        selectMarket() {
            this.filterFacebook.filterCountriesFacebook='';
            this.getPrefixMarket(this.filterFacebook.filterMarketAreaFacebook);
            this.listMarketArea.map(item => {
                if (item.id === this.filterFacebook.filterMarketAreaFacebook) {
                    this.filterFacebook.filterMarketCode = item.code;
                }
            })
        },
        sumTotalReportFacebook(data, type) {
            let result = 0;
            let temp =
                data[0] &&
                data[0].sessions[0] &&
                data[0].sessions[0].value[0]
                 ? data[0].sessions[0].value[0]
                 : null;

            if (type === 'authentication' && temp) {
                let totalAuth =
                    temp &&
                    temp.total_authentication
                        ? +temp.total_authentication
                        : 0;
                let freeTier =
                    temp &&
                    temp.free_tier_authentication
                        ? +temp.free_tier_authentication
                        : 0;
                let entryPoint =
                    temp &&
                    temp.free_entry_point_authentication
                        ? +temp.free_entry_point_authentication
                        : 0;

                result = totalAuth + freeTier + entryPoint;
            } else if (type === 'marketing' && temp) {
                let totalMarketing =
                    temp &&
                    temp.total_marketing
                        ? +temp.total_marketing
                        : 0;
                let freeTier =
                    temp &&
                    temp.free_tier_marketing
                        ? +temp.free_tier_marketing
                        : 0;
                let entryPoint =
                    temp &&
                    temp.free_entry_point_marketing
                        ? +temp.free_entry_point_marketing
                        : 0;

                result = totalMarketing + freeTier + entryPoint;
            } else if (type === 'utility' && temp) {
                let totalUtility =
                    temp &&
                    temp.total_utility
                        ? +temp.total_utility
                        : 0;
                let freeTier =
                    temp &&
                    temp.free_tier_utility
                        ? +temp.free_tier_utility
                        : 0;
                let entryPoint =
                    temp &&
                    temp.free_entry_point_utility
                        ? +temp.free_entry_point_utility
                        : 0;

                result = totalUtility + freeTier + entryPoint;
            } else if (type === 'service' && temp) {
                let totalService =
                    temp &&
                    temp.total_service
                        ? +temp.total_service
                        : 0;
                let freeTier =
                    temp &&
                    temp.free_tier_service
                        ? +temp.free_tier_service
                        : 0;
                let entryPoint =
                    temp &&
                    temp.free_entry_point_service
                        ? +temp.free_entry_point_service
                        : 0;

                result = totalService + freeTier + entryPoint;
            } else if (type === 'paidAuthentication' && temp) {
                result =
                    temp &&
                    temp.regular_authentication
                        ? temp.regular_authentication
                        : 0;
            } else if (type === 'paidMarketing' && temp) {
                result =
                    temp &&
                    temp.regular_marketing
                        ? temp.regular_marketing
                        : 0;
            } else if (type === 'paidUtility' && temp) {
                result =
                    temp &&
                    temp.regular_utility
                        ? temp.regular_utility
                        : 0;
            } else if (type === 'paidService' && temp) {
                result =
                    temp &&
                    temp.regular_service
                        ? temp.regular_service
                        : 0;
            } else if (type === 'tierAuthentication' && temp) {
                result =
                    temp &&
                    temp.free_tier_authentication
                        ? temp.free_tier_authentication
                        : 0;
            } else if (type === 'tierMarketing' && temp) {
                result =
                    temp &&
                    temp.free_tier_marketing
                        ? temp.free_tier_marketing
                        : 0;
            } else if (type === 'tierUtility' && temp) {
                result =
                    temp &&
                    temp.free_tier_utility
                        ? temp.free_tier_utility
                        : 0;
            } else if (type === 'tierService' && temp) {
                result =
                    temp &&
                    temp.free_tier_service
                        ? temp.free_tier_service
                        : 0;
            } else if (type === 'entryAuthentication' && temp) {
                result =
                    temp &&
                    temp.free_entry_point_authentication
                        ? temp.free_entry_point_authentication
                        : 0;
            } else if (type === 'entryMarketing' && temp) {
                result =
                    temp &&
                    temp.free_entry_point_marketing
                        ? temp.free_entry_point_marketing
                        : 0;
            } else if (type === 'entryUtility' && temp) {
                result =
                    temp &&
                    temp.free_entry_point_utility
                        ? temp.free_entry_point_utility
                        : 0;
            } else if (type === 'entryService' && temp) {
                result =
                    temp &&
                    temp.free_entry_point_service
                        ? temp.free_entry_point_service
                        : 0;
            } else if (type === 'revenueAuthentication' && temp) {
                result =
                    temp &&
                    temp.revenue_authentication
                        ? temp.revenue_authentication.toLocaleString('id-ID')
                        : 0;
            } else if (type === 'revenueMarketing' && temp) {
                result =
                    temp &&
                    temp.revenue_marketing
                        ? temp.revenue_marketing.toLocaleString('id-ID')
                        : 0;
            } else if (type === 'revenueUtility' && temp) {
                result =
                    temp &&
                    temp.revenue_utility
                        ? temp.revenue_utility.toLocaleString('id-ID')
                        : 0;
            } else if (type === 'revenueService' && temp) {
                result =
                    temp &&
                    temp.revenue_service
                        ? temp.revenue_service.toLocaleString('id-ID')
                        : 0;
            }

            return result;
        },
        async searchDamcorp() {
            this.loadingReportTable = true;
            await this.getTrafficReport();
            await this.getDamcorpReport();
            this.loadingReportTable = false;
        },
        searchFacebook() {
            this.getFacebookData();
            this.getReportFacebookData();
        },
        async paginateTraffic(page) {
			this.currentPageTraffic = page
			await this.getTrafficReport(this.currentPageTraffic)
		},
        objectSpanMethod({
            row,
            column,
            rowIndex,
            columnIndex,
        }) {
            if (columnIndex === 0) {
                if (rowIndex % 2 === 0) {
                return {
                    rowspan: 2,
                    colspan: 1,
                }
                } else {
                return {
                    rowspan: 0,
                    colspan: 0,
                }
                }
            }
        },
        uploadFile(object){
            let maxSizeAllowed = 500 * 1000 // bytes * 1000
            if(object.file.size > maxSizeAllowed){
                this.$swal(this.$t('warning'), this.$t(`upload_max_size`), "warning")
            }
        },
        formatDateHour(value) {
            return moment(value).format('YYYY-MM-DD hh:mm');
        },
        formatDate(value) {
            return moment(value).format('YYYY-MM-DD');
        },
        selectClientFilter(type) {
            this.listCustomerClient = [];
            this.listPhoneNumber = [];
            this.filterDamcorp.companyName = ''
            this.filterDamcorp.phoneNumber = ''
            this.listClient.map(item => {
                if (item.id === this.filterDamcorp.clientName) {
                    this.listCustomerClient = item.master_client_assigns;
                }
            })

            if (type === 'download') {
                this.listCustomerClientDownload = [];
                this.listPhoneNumberDownload = [];
                this.filterDownload.companyName = ''
                this.filterDownload.phoneNumber = ''
                this.listClient.map(item => {
                    if (item.id === this.filterDownload.clientName) {
                        this.listCustomerClientDownload = item.master_client_assigns;
                    }
                })
            }
        },
        selectPhoneNumber(type) {
            let id =
                this.filterDamcorp &&
                this.filterDamcorp.companyName
                    ? this.filterDamcorp.companyName
                    : '';
            this.loadNumber(1, 'search');

            if (type == 'download'){
                let id =
                    this.filterDownload &&
                    this.filterDownload.companyName
                        ? this.filterDownload.companyName
                        : '';
                this.loadWA(id, type);
            } else if (type == 'damcorp') {
                let id =
                    this.filterDamcorp &&
                    this.filterDamcorp.companyName
                        ? this.filterDamcorp.companyName
                        : '';
                this.loadWA(id, type);
            }
        },
        selectPhoneNumberFilterFacebook(type) {
            let id =
                this.filterFacebook &&
                this.filterFacebook.filterWabaIdFacebook
                    ? this.filterFacebook.filterWabaIdFacebook
                    : '';
            this.filterFacebook.filterPhoneNumberFacebook='';
            this.loadWA(id, type);
        },
        async loadNumber(page=1, type) {
            this.listPhoneNumber = [];
            this.listPhoneNumberDownload = [];
            this.listPhoneNumberFacebook = [];
			let params = {
                page: page,
                limit: 1000,
                client_id: this.filterDamcorp.clientName,
                customer_id: this.filterDamcorp.companyName
            };

            await api({
                method: 'get',
                url:config.baseApi+'master-client-assign',
                params
            }).then(result => {
                var data =
                    result &&
                    result.data &&
                    result.data.data &&
                    result.data.data.rows
                        ? result.data.data.rows
                        : [];
                var status =
                    result &&
                    result.data &&
                    result.data.ec
                        ? result.data.ec
                        : null;

                if (status === 200) {
                    this.listPhoneNumber = data;
                } else {
                    this.listPhoneNumber = [];
                }
            }).catch(error => {
                console.error("Failed : " + error);
            })
        },
        async loadWA(id, type) {
            this.listPhoneNumberDownload = [];
            this.listPhoneNumberFacebook = [];
			await api({
				method: 'post',
				url: config.baseApi +'user/'+id+'/detail_number'
			}).then(result => {
                const status =
                    result &&
                    result.data &&
                    result.data.ec
                        ? result.data.ec
                        : null;
                const data =
                    result &&
                    result.data &&
                    result.data.data
                        ? result.data.data
                        : [];

				if(status == 200){
                    if (type === 'facebookFilter') {
                        this.listPhoneNumberFacebook = data;
                    } else if (type === 'download') {
                        this.listPhoneNumberDownload = data;
                    }
				} else {
                    this.listPhoneNumberDownload = [];
                }
			}).catch(error => {
                console.log('Error:', error)
			})
		},
        async listClientName() {
            this.loadingPage=true;
            await api({
				url:config.baseApi+'master-client-all',
				method:'GET'
			}).then(response => {
                let data =
                    response &&
                    response.data &&
                    response.data.data &&
                    response.data.data.rows
                        ? response.data.data.rows
                        : [];
                let status =
                    response &&
                    response.data &&
                    response.data.ec
                        ? response.data.ec
                        : null;

                if (status === 200) {
                    this.listClient = data
                }
			}).catch(error => {
				console.error(error);
			})
            this.loadingPage=false;
        },
        async getTrafficReport(page = 1) {
            this.loadingTable = true;
            let data = {
                year: moment(this.filterDamcorp.selectedStartDate[0]).format('YYYY'),
                startDate: moment(this.filterDamcorp.selectedStartDate[0]).format('YYYY-MM-DD'),
                endDate: moment(this.filterDamcorp.selectedStartDate[1]).format('YYYY-MM-DD'),
                number: this.filterDamcorp.phoneNumber,
                customer_id: this.filterDamcorp.companyName
            };

            let param = {
                page: page
            }

            await api({
				url: config.baseApi+'master-business/report/traffic',
				method: 'POST',
                data: data,
                params: param
			}).then(response => {
                let data =
                    response &&
                    response.data &&
                    response.data.data &&
                    response.data.data.transactions
                        ? response.data.data.transactions
                        : [];
                let status =
                    response &&
                    response.data &&
                    response.data.ec
                        ? response.data.ec
                        : null;
                let total =
                    response &&
                    response.data &&
                    response.data.data.meta &&
                    response.data.data.meta.totalData &&
                    response.data.data.meta.totalData.total
                        ? response.data.data.meta.totalData.total
                        : {};
                this.msgCreated = data.length;
                let sent = [];
                let send = [];
                let delivered = [];
                let read = [];
                let failed = [];

                if (status === 200) {
                    this.listReportTraffic = data;
                    data.map(item => {
                        if (item.status.toLowerCase() === 'sent') {
                            sent.push(item);
                        } else if (item.status.toLowerCase() === 'send') {
                            send.push(item)
                        } else if (item.status.toLowerCase() === 'delivered') {
                            delivered.push(item)
                        } else if (item.status.toLowerCase() === 'read') {
                            read.push(item)
                        } else if (item.status.toLowerCase() === 'failed' || item.status.toLowerCase() === 'invalid') {
                            failed.push(item)
                        }
                    })
                    
                    this.msgSent = sent;
                    this.msgSend = send;
                    this.msgDelivered = delivered;
                    this.msgRead = read;
                    this.msgFailed = failed;
                    this.totalDataReportTraffic = total;
                }

                this.loadingTable = false;

			}).catch(error => {
				console.error(error);
			})
        },
        async getDamcorpReport() {
            let data = {
                year: moment(this.filterDamcorp.selectedStartDate[0]).format('YYYY'),
                startDate: moment(this.filterDamcorp.selectedStartDate[0]).format('YYYY-MM-DD'),
                endDate: moment(this.filterDamcorp.selectedStartDate[1]).format('YYYY-MM-DD'),
                phone_number: this.filterDamcorp.phoneNumber,
                customer_id: this.filterDamcorp.companyName
            };

            await api({
				url: config.baseApi+'master-business/conversation-report',
				method: 'POST',
                data: data
			}).then(response => {
                let data =
                    response &&
                    response.data &&
                    response.data.data
                        ? response.data.data
                        : {};
                let status =
                    response &&
                    response.data &&
                    response.data.ec
                        ? response.data.ec
                        : null;

                if (status === 200) {
                    this.listReportDamcorp = data;
                } else {
                    this.listReportDamcorp = {};
                }

			}).catch(error => {
				console.error(error);
			})
        },
        async getFacebookData(page = 1) {
            this.loadingReportTable=true;
            let params = {
                filter: 'waba_id',
                search: '',
                startDate: moment(this.filterFacebook.selectedStartDate[0]).format('YYYY-MM-DD'),
                endDate: moment(this.filterFacebook.selectedStartDate[1]).format('YYYY-MM-DD')
            };

            await api({
				url: config.baseApi+'master-business/get-fb-sessions-summary',
				method: 'get',
                params: params
			}).then(response => {
                let status =
                    response &&
                    response.data &&
                    response.data.ec
                        ? response.data.ec
                        : null;
                let data =
                    response &&
                    response.data &&
                    response.data.data &&
                    response.data.data.data
                        ? response.data.data.data
                        : {};

                if (status === 200) {
                    this.listFacebookData = data;
                }
                this.loadingReportTable=false;
			}).catch(error => {
				console.error(error);
                this.loadingReportTable=false;
			})
        },
        async getReportFacebookData() {
            this.loadingReportTable=true;
            let params = {
                filter: 'phone_number',
                search: this.filterFacebook.filterPhoneNumberFacebook,
                startDate: moment(this.filterFacebook.selectedStartDate[0]).format('YYYY-MM-DD'),
                endDate: moment(this.filterFacebook.selectedStartDate[1]).format('YYYY-MM-DD'),
                market: this.filterFacebook.filterMarketCode,
                country: this.filterFacebook.filterCountriesFacebook
            };

            await api({
				url: config.baseApi+'master-business/get-fb-sessions',
				method: 'get',
                params: params
			}).then(response => {
                let status =
                    response &&
                    response.data &&
                    response.data.ec
                        ? response.data.ec
                        : null;
                let data =
                    response &&
                    response.data &&
                    response.data.data &&
                    response.data.data.data
                        ? response.data.data.data
                        : {};

                if (status === 200) {
                    this.listReportFacebookData = data;
                }
                this.loadingReportTable=false;
			}).catch(error => {
				console.error(error);
                this.loadingReportTable=false;
			})
        },
        async loadConsumen() {
            await api({
                url: config.baseApi + "notification/consumen",
                method: 'get'
            })
            .then(res => {
                let data =
                    res &&
                    res.data &&
                    res.data.data &&
                    res.data.data.consumen
                        ? res.data.data.consumen
                        : [];
                let status =
                    res &&
                    res.data &&
                    res.data.ec
                        ? res.data.ec
                        : null;
				if(status === 200){
					this.listCustomer = data;
				}
            })
            .catch(err => {
                console.error(err);
            })
        },
        async getConsumen(){
			await api({
				method: "get",
				url: config.baseApi + "consumen",
				params: {
                    customer_type: 2,
					query_by: 'waba_number',
                    dropdown: true
				}
			}).then(resp => {
                const status =
                    resp &&
                    resp.data &&
                    resp.data.ec
                        ? resp.data.ec
                        : null;
                const data =
                    resp &&
                    resp.data &&
                    resp.data.data &&
                    resp.data.data.consumen
                        ? resp.data.data.consumen
                        : [];
				if(status == 200){
                    this.consumenData = data;
				}
			}).catch(err => {
				console.log("failed", err)
			})
		},
        async downloadCategoryReport() {
            let params = {
                number: this.filterDamcorp.phoneNumber,
                startDate: moment(this.filterDamcorp.selectedStartDate[0]).format('YYYY-MM-DD'),
                endDate: moment(this.filterDamcorp.selectedStartDate[1]).format('YYYY-MM-DD'),
                download: true
            };

            if (this.download_category !== 'realisasi') {
                params.reportingType = this.download_category;
            }

            let apiOptions = {
                url: config.baseApi + `user/${this.filterDamcorp.companyName}/report/notification/download`,
                method: 'GET',
                params: params
            }

            if (this.download_category === 'realisasi') {
                apiOptions.url = config.baseApi + `user/${this.filterDamcorp.companyName}/report/notification/download-realisasi`,
                apiOptions.params = params
            }

            let requestOptions = {
                method: 'GET',
                headers: {
                    'api-key': store.getters.accessToken
                }
            };

            if (this.download_category === 'realisasi') {
                return fetch(
                    `${config.baseApi}user/${this.filterDamcorp.companyName}/report/notification/download-realisasi?startDate=${moment(this.filterDamcorp.selectedStartDate[0]).format('YYYY-MM-DD')}&endDate=${moment(this.filterDamcorp.selectedStartDate[1]).format('YYYY-MM-DD')}&number=${this.filterDamcorp.phoneNumber}&download=true`,
                    requestOptions
                )
                    .then((response) => response.blob())
                    .then((blob) => {
                        const blobData = new Blob([blob], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
                        var url = window.URL.createObjectURL(blobData);
                        var a = document.createElement("a");
                        a.href = url;
                        a.download = `Report Realisasi DAMCORP ${moment(this.filterDamcorp.selectedStartDate[0]).format('YYYY-MM-DD')} - ${moment(this.filterDamcorp.selectedStartDate[1]).format('YYYY-MM-DD')} (${this.filterDamcorp.phoneNumber}).xlsx`;
                        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
                        a.click();
                        a.remove();
                    })
                    .catch((err) => console.log('Failed: ', err));
            } else {
                await api(apiOptions).then(response => {
                    let status =
                        response &&
                        response.data &&
                        response.data.ec
                            ? response.data.ec
                            : null;
                    let dataDownload =
                        response &&
                        response.data
                            ? response.data
                            : '';
                    let message =
                        response &&
                        response.data &&
                        response.data.message
                            ? response.data.message
                            : '';

                    if (message === 'success' || message === 'waiting' || status === 200) {
                        this.$swal(this.$t('success'), 'Download success!', "success");
                        this.activeTab = 'download';
                        this.loadDataDownload();
                    } else {
                        this.$swal(this.$t('error'), 'Download failed!', "error");
                    }
                }).catch(error => {
                    console.error('Failed: ', error);
                })
            }
        },
        searchReportDownload() {
            this.loadDataDownload();
        },
        async loadDataDownload(page = 1) {
			this.loadingDownloadReport = true;
            this.loadingReportDownload = true;

            // filterDownload: {
            //     selectedStartDate: moment().format("YYYY-MM-DD"),
            //     clientName: '',
            //     companyName: '',
            //     phoneNumber: ''
            // }

            let param = {
                page: page,
                date: this.filterDownload.selectedStartDate,
                number: this.filterDownload.phoneNumber
            };

			await api({
				method: "GET",
				url: "report/list",
                params: param
			}).then(response => {
                let data =
                    response &&
                    response.data &&
                    response.data.data &&
                    response.data.data.docs
                        ? response.data.data.docs
                        : [];
                let total =
                    response &&
                    response.data &&
                    response.data.data &&
                    response.data.data.count
                        ? response.data.data.count
                        : 0;
                let status =
                    response &&
                    response.data &&
                    response.data.ec
                        ? response.data.ec
                        : null;

                if (status === 200) {
                    this.reportsDownload = data.map(v => {
                    	v.title = "Report " + v.customerName
                    	v.downloadUrl = v.url ? v.url.secure_url : null
                    	return v
                    })
                    this.totalReportDownload = total
                }
			})
			.catch(error => {
				this.$swal(this.$t('error'), error.message, "error")
            })
			this.loadingDownloadReport = false;
            this.loadingReportDownload = false;
		},
		async deleteReport(session){
			try {
				await this.$confirm(`You will permanently delete this file. Are you sure?`, 'Confirm', {
					confirmButtonText: 'Sure',
					cancelButtonText: 'Cancel',
					dangerouslyUseHTMLString: true,
					type: 'warning',
					center: true
				})
				this.loadingDownloadReport = true
				await api({
					method: "DELETE",
					url: "report/" + session
				}).then(response => {
					if(response.data.ec == 200){
						this.$swal(this.$t('success'), "", "success")
					} else{
						this.$swal(this.$t('error'), "Sorry, delete file failed. Please try again", "error")
					}
				})
				.catch(error => {
					this.$swal(this.$t('error'), error.message, "error")
				})
				this.loadDataDownload()
				this.loadingDownloadReport = false
			} catch(err){

			}
		},
        async getWabaFbbmId(filter = '') {
            await api({
				url: config.baseApi+'bussiness/get-fb-identity',
				method: 'GET',
				params: {
					all: true,
					filter: filter,
                    limit: 2000
				}
			}).then(res => {
                let dataTemp =
                    res &&
                    res.data &&
                    res.data.data &&
                    res.data.data.consumen
                        ? res.data.data.consumen
                        : [];

                let dataWaba = dataTemp.filter(item => item.type === 'waba_id');
                let dataFbbm = dataTemp.filter(item => item.type === 'fbbm_id');
				switch (filter) {
					case "waba_id":
						this.fbIdentityWaba = this.fbIdentityWaba.concat(dataWaba)
						break;
					case "fbbm_id":
						this.fbIdentityFbbm = this.fbIdentityFbbm.concat(dataFbbm)
						break;
				}
			}).catch(error => {
				console.log(error);
			})
        },
        async getAssign(){
            var params = {
                limit: 1000
            };

            await api({
                method: 'get',
                url:config.baseApi+'master-client-assign',
                params
            }).then(result => {
                var data =
                    result &&
                    result.data &&
                    result.data.data &&
                    result.data.data.rows
                        ? result.data.data.rows
                        : [];
                var status =
                    result &&
                    result.data &&
                    result.data.ec
                        ? result.data.ec
                        : null;
                var total =
                    result &&
                    result.data &&
                    result.data.data &&
                    result.data.data.count
                        ? result.data.data.count
                        : 0;
                if(status === 200) {
                    this.assignData = data;
                }
            }).catch(error => {
                console.error("Failed : " + error);
            })
	    },
        async getListMarket(){
			await api({
				method: "get",
				url: config.baseApi + "data/market-area"
			}).then(resp => {
                const status =
                    resp &&
                    resp.data &&
                    resp.data.ec
                        ? resp.data.ec
                        : null;
                const data =
                    resp &&
                    resp.data &&
                    resp.data.data &&
                    resp.data.data.rows
                        ? resp.data.data.rows
                        : [];
				if(status == 200){
                    this.listMarketArea = data;
				}
			}).catch(err => {
				console.log("failed", err)
			})
		},
        async getPrefixMarket(id){
            var params = {
                master_market_area_id: id
            }

            await api({
                method: 'get',
                url:config.baseApi+'master-prefix',
                params
            }).then(result => {
                var data =
                    result &&
                    result.data &&
                    result.data.data &&
                    result.data.data.rows
                        ? result.data.data.rows
                        : [];
                var status =
                    result &&
                    result.data &&
                    result.data.ec
                        ? result.data.ec
                        : null;
                var total =
                    result &&
                    result.data &&
                    result.data.data &&
                    result.data.data.count
                        ? result.data.data.count
                        : 0;
                if(status === 200) {
                    this.marketPrefixData = data;
                }
            }).catch(error => {
                console.error("Failed : " + error);
            })
	    }
	},
	async mounted(){
        await this.listClientName();
        await this.getTrafficReport();
        await this.loadConsumen();
        await this.getFacebookData(1);
        await this.getDamcorpReport();
        await this.loadDataDownload();
        await this.getWabaFbbmId('waba_id');
        await this.getWabaFbbmId('fbbm_id');
        await this.getAssign();
        await this.getListMarket();
        await this.getConsumen();
        await this.getReportFacebookData();
	}
}
</script>
<style>
    .swal2-container {
        z-index: 10000 !important;
    }
    .table-report {
        border-collapse: collapse;
        overflow: hidden;
        box-shadow: 0 0 20px rgba(0,0,0,0.1);
    }

    .table-report th,
    .table-report thead td {
        background-color: rgba(255,255,255,0.2);
        color: #fff;
    }

    .table-report thead,
    .table-report th {
        background-color: #191D24;
    }

    .table-report tbody,
    .table-report tr:hover {
        background-color: rgba(255,255,255,0.3);
    }
</style>
<style lang="scss">
@import '../../assets/scss/_variables';
.chart {
     width: 100%;
     height: 400px;
 }
.page-invoice {
	.toolbar {
		max-width: 794px;
		margin: 0 auto;
		text-align: right;
		margin-bottom: 20px;
	}

	.invoice {
		background: white;
		width: 100%;
		max-width: 794px;
		min-height: 1123px;
		margin: 0 auto;
		padding: 2em;
		box-sizing: border-box;
		box-shadow: 0px 8px 8px -8px rgba(0, 0, 0, 0.3);

		hr {
			border: 1px solid rgba(0, 0, 0, 0.05);
		}

		.invoice-top {
			overflow: hidden;
			margin-bottom: 30px;

			.logo {
				float: left;
				height: 60px;
				width: 60px;
				box-sizing: border-box;
				border-radius: 50%;
				overflow: hidden;
				background: rgba(0, 0, 0, 0.07);
				text-align: center;

				img {
					height: 80%;
					margin-top: 10%;
				}
			}
			.info {
				display: block;
				float:left;
				margin-left: 20px;
				margin-top: 5px;

				& > * {
					margin: 0;
				}
			}
			.title {
				float: right;

				& > * {
					margin: 0;
				}

				p {
					text-align: right;
				}
			}
		}

		.invoice-middle {
			overflow: hidden;
			margin-top: 30px;
			margin-bottom: 30px;

			.clientlogo {
				float: left;
				height: 60px;
				width: 60px;
				box-sizing: border-box;
				border-radius: 50%;
				overflow: hidden;
				background: grey;

				img {
					width: 100%;
				}
			}

			.info {
				display: block;
				float:left;
				margin-left: 20px;
				margin-top: 5px;

				& > * {
					margin: 0;
				}
			}

			.project {
				margin-left: 52%;

				& > * {
					margin: 0;
				}
			}
		}

		.invoice-bottom {
			table {
				width: 100%;
				border-collapse: collapse;

				th {
					text-align: right;
					padding: 20px;
					padding-bottom: 5px;
					opacity: .7;

					&:first-child {
						text-align: left;
						padding-left: 0px;
						// width: 100%
					}
					&:last-child {
						padding-right: 0px;
					}
				}

				td {
					text-align: right;
					padding: 20px;
					padding-bottom: 5px;
					border-bottom: 1px solid #EEE;

					&:first-child {
						text-align: left;
						padding-left: 0px;
						// width: 100%;
					}
					&:last-child {
						padding-right: 0px;
					}
				}

				tfoot td {
					border: none;
					padding-top: 5px;
				}
			}
		}

		h1 { font-size: 1.5em; color: #222; }
		h2 { font-size: .9em; }
		h3 { font-size: 1.2em; font-weight: 300; line-height: 2em; }
		p  { font-size: .7em; color: #666; line-height: 1.2em; }
	}

}


@media screen and (max-width: 768px) {
	.page-invoice {
		.invoice {
			.invoice-middle {
				.project {
					display: block;
					width: 100%;
					clear: both;
					padding: 10px 0;
					margin: 0;
				}
			}
			.invoice-bottom {
				table {
					th {
						padding: 5px;
					}

					td {
						padding: 5px;
					}
				}
			}
		}
	}
}

@media print{
	.layout-container .container .footer ,
	.layout-container .container .header ,
	.layout-container .container .horizontal-nav ,
	.layout-container .footer ,
	.layout-container .layout-picker ,
	.layout-container .vertical-nav ,
	.layout-container .header {
		display:none;
	}

	.page-invoice {
		.toolbar {
			display: none;
		}

		.invoice {
			box-shadow: none;
			max-width: 100%;
			padding: 0;
		}
	}
}
</style>
<style lang="scss" scoped>
.float-image {
	float:right;
	z-index: 1;
	bottom: 10px;
	left: 10px;
}
.fl-r {
	float:right;
}
.gradient-api {
	background:#249393;
	background: linear-gradient(260deg, #4ac5c5, #249393);
}
.white-text {
	color: white;
}
.page-header {
	margin-bottom: 30px;
}
</style>
